import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import * as socketIo from 'socket.io-client';
import { UsuarioService } from '../usuario/usuario.service';

@Injectable({
  providedIn: 'root'
})
export class AlarmasService {

  private chatURL = 'http://172.16.70.13:3100';

  constructor(private usuarioService: UsuarioService ) { }

  // private socket;
  // macs;

  //   public send(message) {
  //       this.socket.emit('add-message', message);
  //   }

  //   public sendUbicacion(ubicacion: string) {
  //     this.socket.emit('url-ubicacion', ubicacion);
  //   }

  //   getMessages() {
  //       let observable = new Observable(observer => {
  //         this.socket = socketIo(this.chatURL);
  //         this.socket.on('message', (data) => {
  //           observer.next(data);
  //         });
  //         return () => {
  //           this.socket.disconnect();
  //         };
  //       })
  //       return observable;
  //     }

  //   public socketConnect(){
  //     this.socket = socketIo.connect(this.chatURL);
  //     this.socket.on('message', (data) => {
  //       console.log(data);
  //     });
  //   }

  //   public getUbicacion(){
  //     let observable = new Observable(observer => {
  //       this.socket.on('ubicacion', (data) => {
  //         observer.next(data);
  //         // console.log(data);
  //       });
  //     })
  //     return observable;
  //   }

  //   public getEvento(){
  //     let observable = new Observable(observer => {
  //       this.socket.on('evento', (data) => {
  //         observer.next(data);
  //         // console.log(data);
  //       });
  //     })
  //     return observable;
  //   }

  //   public sendAlertasData(data){
  //     this.socket.emit('add-alerta-data', data);
  //   }

  //   public getlertasData(){
  //     let observable = new Observable(observer => {
  //       this.socket.on('alerta-data', (data) => {
  //         observer.next(data);
  //         // console.log(data);
  //       });
  //     })
  //     return observable;
  //   }

  //   public sendUsuarioMac(data){
  //     this.socket.emit('registrar-mac', data);
  //   }

  //   public getPrueba(){
  //     // let observable = new Observable(observer => {
  //     //   this.socket.on('evento2', (data) => {
  //     //     observer.next(data);
  //     //     // console.log(data);
  //     //   });
  //     // })
  //     // return observable;

  //     let observable = new Observable(observer => {
  //       this.usuarioService.getUsuarioMac().subscribe(mac => {
  //         this.macs = mac;
  //         this.macs.forEach(element => {
  //           this.socket.on(element.c_mac, (data) => {
  //             observer.next(data);
  //             // console.log(data);
  //           });
  //         });

  //       });
  //       // this.socket.on('evento2', (data) => {
  //       //   observer.next(data);
  //       //   // console.log(data);
  //       // });
  //     })
  //     return observable;
  //   }

  //   public socketDisconnect(){
  //     this.socket.disconnect();
  //   }

}
